export default __webpack_public_path__ + "locales/nl/MainBar.json?hash=fdcfee2b9b1088d3290e16f99331a34d";